var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestParentBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.47,
    height: 22.764,
    viewBox: "0 0 23.47 22.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(418.608 -236.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M-414.5,263.89l6.921,6.935a1.262,1.262,0,0,1,.156-.254q1.54-1.55,3.088-3.092c.32-.32.517-.32.834,0q2.226,2.225,4.45,4.451c.32.32.319.524,0,.832a7.567,7.567,0,0,1-4.339,2.05,11.269,11.269,0,0,1-7.683-1.828,16.858,16.858,0,0,1-6.354-6.969,11.267,11.267,0,0,1-1.179-5,7.931,7.931,0,0,1,2.164-5.673c.289-.3.5-.305.792-.014q2.246,2.244,4.489,4.49c.3.3.3.5-.007.813q-1.544,1.546-3.092,3.088A1.855,1.855,0,0,1-414.5,263.89Z",
    transform: "translate(0 -15.589)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(-410.145 236.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M-256.853,324.457a3.174,3.174,0,0,0-1.072,1.487.254.254,0,0,1-.271.183,3.534,3.534,0,0,0-.9.138,1.2,1.2,0,0,0-.85,1.167,2.83,2.83,0,0,0,.193,1.428.415.415,0,0,1,.019.09c-.625.217-.733.767-.836,1.311-.066.351-.1.709-.144,1.065-.011.085-.017.154-.136.154-1.239,0-2.478,0-3.716,0a.736.736,0,0,1-.092-.012.792.792,0,0,1-.01-.1c.045-1.232.065-2.466.144-3.7a12.073,12.073,0,0,1,.613-3.312,3.223,3.223,0,0,1,.941-1.491,1.486,1.486,0,0,1,.942-.347,1.147,1.147,0,0,1,.432.091,3.229,3.229,0,0,0,2.7.038,1.053,1.053,0,0,1,1.408.367,3.589,3.589,0,0,1,.307.6C-257.06,323.884-256.964,324.163-256.853,324.457Z",
    transform: "translate(264.667 -316.674)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M-148.529,361.311h-6.111c-.108-.463-.195-.9-.316-1.335a1.792,1.792,0,0,0-.732-1.115,1.556,1.556,0,0,1,.054-.158,3.426,3.426,0,0,0,.208-1.533,1.163,1.163,0,0,0-.545-.936,3.243,3.243,0,0,1,.926-1.4,1.312,1.312,0,0,1,.817-.295.815.815,0,0,1,.317.067,3.133,3.133,0,0,0,2.314.127.358.358,0,0,0,.08-.033.913.913,0,0,1,.76-.128,1.564,1.564,0,0,1,.808.51,4.494,4.494,0,0,1,.861,1.8,14.444,14.444,0,0,1,.456,2.818C-148.593,360.223-148.565,360.748-148.529,361.311Z",
    transform: "translate(163.535 -346.469)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M-228.09,244.248a2.812,2.812,0,0,1-1.543-.427,1.955,1.955,0,0,1-.841-1.8,14.775,14.775,0,0,1,.2-1.945,1.936,1.936,0,0,1,1.66-1.509,3.15,3.15,0,0,1,1.612.226,1.975,1.975,0,0,1,1.222,2.379,13.345,13.345,0,0,1-.452,1.6,2.016,2.016,0,0,1-1.39,1.407A3.861,3.861,0,0,1-228.09,244.248Z",
    transform: "translate(232.855 -238.538)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M-145.6,284.866c.142-.159.284-.318.425-.478a.763.763,0,0,0,.16-.789,3.65,3.65,0,0,1-.2-1.432,1.929,1.929,0,0,1,1.651-1.769,2.065,2.065,0,0,1,2.453,1.952,5.089,5.089,0,0,1,.028.762.809.809,0,0,0,.379.75c.162.109.328.213.515.334-.246.069-.474.137-.7.2a1.9,1.9,0,0,0-.767.375,2.312,2.312,0,0,1-1.164.541,2.32,2.32,0,0,1-1.369-.279,1.029,1.029,0,0,0-.392-.109c-.339-.015-.679,0-1.018,0Z",
    transform: "translate(153.885 -277.453)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M-198,425.575c.092-.464.144-.9.267-1.307a.765.765,0,0,1,.834-.614c.158.016.31.109.466.115a1.783,1.783,0,0,0,.626-.064.723.723,0,0,1,.859.247,2.094,2.094,0,0,1,.326,1.046c.02.183.02.367.03.577Z",
    transform: "translate(202.64 -410.768)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M-189.222,383.854a1.069,1.069,0,0,1,.34-.989,1.457,1.457,0,0,1,1.625-.011.848.848,0,0,1,.344.706,6.99,6.99,0,0,1-.074.9.988.988,0,0,1-1.113.86,1,1,0,0,1-1.065-.964C-189.189,384.187-189.2,384.02-189.222,383.854Z",
    transform: "translate(194.477 -372.586)",
    fill: "#1a1a1a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestParentBlack);
export default __webpack_public_path__ + "static/media/RequestParentBlack.1a7fcdb4059fe1f910087a1dd97ecf77.svg";
export { ForwardRef as ReactComponent };